import { HttpErrorResponse, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService, BASE_API_URL, LocalStatusFacade } from '@cnt-workspace/data-access';
import { throwError } from 'rxjs';
import { catchError, first } from 'rxjs/operators';

// cnt-landing-local fork of @curbnturf/auth's unauthenticatedErrorInterceptor
// — that shared interceptor calls AuthFacade.logout(...), which routes
// through auth.effects.ts (not registered in cnt-landing's app.config.ts
// anymore). Calls the local AuthService.signOut() instead. LocalStatusFacade
// sources loggedIn$ from AuthService's own Cognito-backed session, not NgRx.
export const unauthenticatedErrorInterceptor: HttpInterceptorFn = (request: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const auth = inject(AuthService);
  const statusFacade = inject(LocalStatusFacade);

  return next(request).pipe(
    catchError((err) => {
      if (
        err instanceof HttpErrorResponse &&
        err.status === 401 &&
        // we only log them out if the 401 is from our server
        err.url?.includes(BASE_API_URL)
      ) {
        statusFacade.loggedIn$.pipe(first()).subscribe((loggedIn) => {
          if (loggedIn) {
            void auth.signOut('You have been logged out by the server');
          }
        });

        return throwError(() => new Error('You have been logged out by the server'));
      }

      return throwError(() => err);
    }),
  );
};
